import { BorrowerValue } from 'app/models/dto/borrower-value.model';

/**
 * A utitlity function to get the latest/newest value, given a borrower value alias,
 * from an array of borrower values. Returns the borrower value with the greatest lastModified time stamp.
 *
 * @param bvs An array of borrower values
 * @param alias The alias of the borrower value you want the latest of
 * @returns
 */
export function getLatestBV(bvs, alias): BorrowerValue | undefined {
  let latest: BorrowerValue | undefined;
  if (bvs && Array.isArray(bvs)) {
    bvs.forEach(bv => {
      if (bv.alias === alias) {
        if (latest === undefined) {
          latest = bv;
        } else if (latest?.modifiedTimestamp && latest.modifiedTimestamp < bv.modifiedTimestamp) {
          latest = bv;
        }
      }
    });
  }
  return latest;
}
